import React from "react";
import { Grid, Stack } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import FormTextField from "../components/common/FormTextField";
import FormSelectField from "../components/common/FormSelectField";
import FormSwitchField from "../components/common/FormSwitchField";
import SubmitButton from "../components/buttons/SubmitButton";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

// Actions
import {
  createPaymentMethod,
  updatePaymentMethod,
} from "../redux/actions/paymentMethodActions";

import { cleanFormData } from "../helpers/formHelpers";

const PAYMENT_TYPES = [
  { value: "CASH", label: "Cash" },
  { value: "MOBILE_MONEY", label: "Mobile Money" },
  { value: "BANK_TRANSFER", label: "Bank Transfer" },
  { value: "CARD", label: "Credit/Debit Card" },
  { value: "CHEQUE", label: "Cheque" },
];

const paymentMethodSchema = Yup.object({
  name: Yup.string().required("Payment method name is required"),
  type: Yup.string().required("Type is required"),
  active: Yup.boolean(),
});

const CreateOrUpdatePaymentMethodForm = ({
  paymentMethod = null,
  isEditing = false,
  loading = false,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: paymentMethod?.name || "",
    type: paymentMethod?.type || "",
    active: paymentMethod?.active ?? true,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={paymentMethodSchema}
      onSubmit={(values) => {
        const cleanedValues = cleanFormData(values);
        if (isEditing) {
          dispatch(
            updatePaymentMethod({
              id: paymentMethod.id,
              values: cleanedValues,
            }),
          );
        } else {
          dispatch(createPaymentMethod(cleanedValues));
        }
      }}
      enableReinitialize
    >
      {({ dirty, isValid }) => (
        <Form>
          <Stack spacing={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormTextField
                  name="name"
                  label="Method Name (e.g. M-Pesa Till)"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormSelectField
                  name="type"
                  label="Type"
                  options={PAYMENT_TYPES}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} display="flex" alignItems="center">
                <FormSwitchField name="active" label="Active" />
              </Grid>
            </Grid>

            <SubmitButton
              title={isEditing ? "Save Changes" : "Create Method"}
              loading={loading}
              disabled={!dirty || !isValid || loading}
              startIcon={
                isEditing ? <SaveOutlinedIcon /> : <AddCircleOutlineIcon />
              }
              sx={{ mt: 1 }}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default CreateOrUpdatePaymentMethodForm;
